// @ui/shared/Dialer/LoadingDots.tsx
import React from 'react';

const LoadingDots: React.FC<{ className?: string; label?: string }> = ({
  className,
  label = 'Loading',
}) => {
  return (
    <div className={`flex items-center gap-3 ${className ?? ''}`} aria-live="polite" role="status">
      <span className="text-sm text-foreground/90">{label}</span>
      <span className="inline-flex items-center gap-1">
        <span className="size-2.5 rounded-full bg-foreground/80 animate-bounce [animation-delay:-0.2s]" />
        <span className="size-2.5 rounded-full bg-foreground/80 animate-bounce [animation-delay:-0.1s]" />
        <span className="size-2.5 rounded-full bg-foreground/80 animate-bounce" />
      </span>
    </div>
  );
};

export default LoadingDots;
